require('fslightbox')

export class FsLightbox {
  init () {

  }
}

export default FsLightbox
